
import { mapState, mapStores } from 'pinia';
import { defineComponent } from 'vue';
import { NDatePicker, NButton, NButtonGroup } from 'naive-ui';

import { useStationStore } from '~/store/station.store';
import { useWeatherStore } from '~/store/weather.store';
import ComponentBase from '~/components/component-base';
import moment from 'moment';
import { useAdvancedViewStore } from '~/store/advanced-view.store';

import StationExportModal from '~/components/modals/station-export-modal.vue';
import { Station } from '~/api/models/station.model';

export default defineComponent({

    extends: ComponentBase,

    components: {
        NDatePicker,
        NButton,
        NButtonGroup,
        StationExportModal,
    },

    data() {

        const data = {
            isLoading: false,
            shortcuts: {},
        };

        const now = moment().unix() * 1000;

        data.shortcuts[this.$t('advanced_view.last_2_hours')] = [moment().subtract('2', 'h').unix() * 1000, now];
        data.shortcuts[this.$t('advanced_view.last_day ')] = [moment().subtract('1', 'd').unix() * 1000, now];
        data.shortcuts[this.$t('advanced_view.last_week ')] = [moment().subtract('1', 'w').unix() * 1000, now];
        return data;
    },

    computed: {
        ...mapStores(useWeatherStore, useStationStore, useAdvancedViewStore),
        ...mapState(useAdvancedViewStore, ['since', 'before', 'mode', 'selected']),

        title(): string {
            let stationsTitle =  this.selected.slice(0,3). map((station: Station) => this.getStationName(station)).join(', ');
            if(this.selected.length > 3) {
                return stationsTitle + ' + ' + (this.selected.length - 3);
            } else {
                return stationsTitle;
            }

        },

        tvLink(): string {
            if (!this.selected || !this.selected.length) {
                return '';
            }

            const station = this.selected[0];

            return `https://tv.elichens.com/#/dashboard/${station.id}?token=${station.pairing_token}`
        },

    },

    methods: {
        isRangeDateDisabled (
            ts: number,
            type: 'start' | 'end',
            range: [number, number] | null
        ) {
            
            if(range) {
                const delta = Math.abs(ts - range[0]);
                return delta > 31 * 24 * 60 * 60 * 1000;
            }
        
            return false
        },
        async setMode(mode: 'live' | 'hourly') {
            this.$router.replace({ path: this.$route ? this.$route.path : '', query: { ...this.$route.query, mode } });
        },

        async setDatetime(datetime: [number, number]): Promise<void> {
            const start = moment.unix(datetime[0] / 1000).toISOString();
            const end = moment.unix(datetime[1] / 1000).toISOString();
            this.$router.replace({ path: this.$route ? this.$route.path : '', query: { ...this.$route.query, since: start, before: end } });
        },

        async refresh() {
            try {
                this.isLoading = true;
                await this.advancedViewStore.refresh();
            } catch(e) {
                this.showUnhandledError('Coud not refresh page', e);
            } finally {
                this.isLoading = false;
            }
        },

        exportStationData() {
            //@ts-ignore
            this.$refs?.exportModal?.open();
        }
    }
});

